import { dbAndOutletLevel, geoFencingOption } from "./updateGeofenceTypes";
export const ATTENDANCE_DATA_CONFIG_DOMAIN_NAME = "clientconfig";
export const ATTENDANCE_DATA_DOMAIN_TYPE = "regionSpecificGeoDistance";
export const GEO_FENCING_OPTIONS : geoFencingOption[] = [
  {
    id: "attendance",
    label: "Attendance",
  },
  {
    id: "dbAndOutlet",
    label: "DB & Outlet",
  },
];
export const DB_AND_OUTLET_LEVELS : dbAndOutletLevel[] = [
  { id: "region", label: "Region" , level: 0 ,searchParameter : ""},
  { id: "state", label: "State", level: 1 , searchParameter : "region"},
  { id: "area", label: "Area" , level: 2 , searchParameter : "state"},
  { id: "territory", label: "Territory", level: 3 , searchParameter : "area"},
  { id: "district", label: "District" , level: 4 , searchParameter : "district"},
  { id: "town", label: "Town" , level: 5 , searchParameter: "town"},
  { id: "userName", label: "User Name DB" , level: 6 , searchParameter : "users"},
  { id: "outletCode", label: "Outlet Code" , level: 7 , searchParameter : "outletDetails"},
];
export const DB_AND_OUTLET_REGIONS_LIST = [
  {
    id: "east",
    label: "EAST",
  },
  {
    id: "west",
    label: "WEST",
  },
  {
    id: "north",
    label: "NORTH",
  },
  {
    id: "south",
    label: "SOUTH",
  },
];

export const DB_AND_OUTLET_POST_REQUEST_KEY_VALUE_MAPPING = [
  {
    key: "region",
    value: "region",
    level: 0
  },
  {
    key: "state",
    value: "state_code",
    level: 1
  },
  {
    key: "area",
    value: "areaCode",
    level: 2
  },
  {
    key: "territory",
    value: "territory_code",
    level: 3
  },
  {
    key: "district",
    value: "district_code",
    level: 4
  },
  {
    key: "town",
    value: "town_code",
    level: 5
  },
  {
    key: "userName",
    value: "loginId",
    level: 6
  },
  {
    key: "outletCode",
    value: "outletCode",
    level: 7
  },
]